export default "__VITE_ASSET__BZv3Jv5$__"